// @flow
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import TextTruncate from 'react-text-truncate';
import LazyLoad from 'react-lazyload';
import Helper from '../../../helper/Helper';
import CONFIG from '../../../config';
import LocaleLink from '../../common/LocaleLink';
import styles from './SearchProductBox.scss';

const SearchProductBox = (props: Object) => {
    const product = props.product;

    const placeholder = (
        <img
            src={`${CONFIG.BASE_IMG_URL}nr/misc/product-image-default.jpg`}
            alt="Placeholder"
        />
    );
    if (!product || _.isEmpty(product)) {
        return <div />;
    }
    const productName =
        product && product.product_title ? (
            <TextTruncate
                line={2}
                text={product.product_title}
                containerClassName={styles.productName}
            />
        ) : (
            ''
        );

    return (
        <a
            target="_blank"
            href={`${Helper.getAppDomain(
                'catalog',
            )}/${Helper.getLocale()}/catalog/${product.psku_canonical}`}
            className={styles.boxCtr}
        >
            {product && product.image_key ? (
                <div className={styles.imageWrapper}>
                    <LazyLoad
                        height="100%"
                        once
                        placeholder={placeholder}
                        offset={100}
                    >
                        <img
                            src={Helper.getTransformationUrl(product.image_key)}
                        />
                    </LazyLoad>
                </div>
            ) : (
                ''
            )}
            <div className={styles.productDesc}>
                {productName}
                {product.brand ? (
                    <div className={styles.brands}>{product.brand}</div>
                ) : (
                    ''
                )}
            </div>
        </a>
    );
};

SearchProductBox.propTypes = {};

SearchProductBox.getDefaultProps = {};

export default SearchProductBox;



// WEBPACK FOOTER //
// ./src/components/products/searchProductBox/SearchProductBox.js